import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import type { IBusinessAdress } from '@Types/address';
import { OnboardingFormFields } from '@Types/index';

export const updateBusiness = async (props: IBusinessAdress) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/setBusinessAddress`
    : `v2/secureonboarding/user/${customerId}/setBusinessAddress`;
  // eslint-disable-next-line no-useless-catch
  try {
    const { data } = await HttpService.post(url, {
      line1: props[OnboardingFormFields.LINE1],
      line2: props[OnboardingFormFields.APARTMENT],
      city: props[OnboardingFormFields.CITY],
      state: props[OnboardingFormFields.STATE]?.value,
      postalCode: props[OnboardingFormFields.ZIP],
      sameAsPrimary: props[OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY],
    });
    return data;
  } catch (error) {
    throw error;
  }
};
